import React from 'react'

const Admin_Footer = () => {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: '0',
                borderTop: '1px solid #DFE3E8',
                width: '85%',
                paddingBottom: 20,
                zIndex: -1,
                pointerEvents: 'none',
            }}
        >
            <p
                style={{
                    margin: 0,
                    paddingTop: 20,
                    color: '#616161',
                    fontSize: '14px',
                }}
            >
                © ishAyurveda. {new Date().getFullYear()}
            </p>
            <small style={{ color: '#6B6C6F' }}>All rights reserved.</small>
        </div>
    )
}

export default Admin_Footer
